import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//MUI
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";

//components
import AIBreadCrumbs from "../../../components/Common/AIBreadCrumbs";
import ServiceCardAI from "../../../components/Cards/ServiceCardAI";
import ExploreEvents from "../../../components/Sections/ExploreEvents";

//assets
import ServiceHeadImg from "../../../assets/images/service_head_img.png";
import EventsImg from "../../../assets/images/explore_events.png";
import NarrativeImg from "../../../assets/images/narratives.png";
import ScriptImg from "../../../assets/images/script.png";
import CaptionImg from "../../../assets/images/caption.png";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  background: "#F6FAFE",
  "& .main": {
    width: "100%",
    padding: "1rem",
    height: `calc(100% - 48px)`,
    overflowY: "auto",
    "& .services_container": {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "2rem 1rem",
      placeItems: "center",
    },
  },
  "& .individual_section_container": {
    width: "100%",
    height: `calc(100% - 48px)`,
  },
}));


const serviceSections = [
  {
    name: "Explore Events",
    desc: "Discover and browse through trending or upcoming content creation opportunities.",
    serviceHeadImg: ServiceHeadImg,
    serviceImg: EventsImg,
    path: "events",
  },
  {
    name: "Narrative",
    desc: "Craft engaging storylines to guide content structure and flow.",
    serviceHeadImg: ServiceHeadImg,
    serviceImg: NarrativeImg,
    path: "narratives",
  },
  {
    name: "Ideas & Script",
    desc: "Instantly generate fresh ideas and detailed scripts for your content.",
    serviceHeadImg: ServiceHeadImg,
    serviceImg: ScriptImg,
    path: "scripts",
  },
  {
    name: "Caption",
    desc: "Create compelling and contextual captions to enhance audience engagement.",
    serviceHeadImg: ServiceHeadImg,
    serviceImg: CaptionImg,
    path: "caption",
  },
];

const ExploreAI = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedSection, setSelectedSection] = useState("");

  const handleSection = (path) => {
    setSelectedSection(path);
    navigate(`/app/explore_ai/${path}`);
  };

  useEffect(() => {
    const path = location.pathname.split("/")[3];
    if (["events", "scheduled"].includes(path)) {
      // setTabValue(path);
    } else {
      setSelectedSection("");
      navigate("/app/explore_ai");
    }
  }, [location.pathname]);

  return (
    <Container>
      <AIBreadCrumbs />
      {selectedSection === "" ?
        <div className="main">
          <div className="services_container">
            {serviceSections.map(item => (
              <ServiceCardAI key={item?.name} data={item} handleSection={handleSection} />
            ))}
          </div>
        </div> :
        <></>
      }
      {selectedSection !== "" ?
        <div className="individual_section_container">
          {selectedSection === "events" ?
            <ExploreEvents /> :
            <></>
          }
        </div> :
        <></>
      }
    </Container >
  );
};

export default ExploreAI;